<template>
  <div class="typegroup">
    <div class="con">
      <div class="left-tree">
        <div class="Files-top">
          <div class="ic-left">
            <span>应用类型组</span>
          </div>
          <div class="btns">
            <el-button type="primary" @click="add_ed" class="last-el-button">新增</el-button>
          </div>
        </div>
        <div class="search" style="margin:20px 0px 12px 0px">
          <el-input placeholder="输入关键字进行过滤" v-model="filterText"></el-input>
        </div>
        <div class="my-tree" style="height:calc(100% - 90px)">
          <el-scrollbar style="height:calc(100% - 20px);width: 100%;">
            <el-tree :data="typeGroupData" show-checkbox node-key="appTypeGroup.id" :props="defaultProps"
              @check="currentChecked" :filter-node-method="filterNode" @node-click='nodeClick_fn' ref="tree">
              <span class="custom-tree-node" slot-scope="{node}"
                style="display: flex;align-items: center;margin:2px 0px">
                <img src="../../../public/static/image/elTree/2.0.png"
                  v-if="node.data.appTypeGroup.entityName == 'AppTypeGroup'" />
                <img src="../../../public/static/image/elTree/variable.png" v-else />
                <span style="padding-left: 5px;">1号电站</span>
                <div class="sh" style="margin-left:5px" v-if="typeGroupID == node.data.appTypeGroup.id">
                  <i class="el-icon-edit-outline" style="margin-left:15px;color:#ebb563;font-size: 20px;"
                    @click.stop="edit_ed(node.data.appTypeGroup)"></i>
                  <i class="el-icon-delete-solid" style="margin-left:15px;color:#f56c6c;font-size: 20px;"
                    @click.stop="delete_fn(node.data.appTypeGroup)"></i>
                </div>




              </span>
            </el-tree>
          </el-scrollbar>
        </div>

      </div>
      <div class="dra-btns">
        <div class="left-add" @click="add">添加<img src="@/assets/left.png" alt=""></div>
        <div class="del" @click="del">移除<img src="@/assets/right.png" alt=""></div>
        <div class="item left-add" style="margin-top:60px;margin-bottom:20px" @click="move_fn('UP')">上移<img
            src="../../../public/static/image/elTree/shang.png" /> </div>
        <!-- <el-button type="success" @click="move_fn('UP')" :disabled="moveDisabled" >上升 <i class="el-icon-arrow-up"></i></el-button> -->
        <!-- <el-button type="info" @click="move_fn('DOWN')" :disabled="moveDisabled">下降 <i class="el-icon-arrow-down"></i></el-button> -->
        <div class="item left-add" @click="move_fn('DOWN')">下移<img
            src="../../../public/static/image/elTree/jiang.png" /></div>

      </div>
      <div class="right-table">
        <div class="Files-top">
          <div class="ic-left">
            <span>未分配组的应用类型列表</span>
          </div>
          <div class="btns">
            <!-- <el-button type="primary" @click="add_ed" class="last-el-button">新增</el-button> -->
          </div>
        </div>
        <div class="search-input-btn" style="width:100%">
          <div class="input-small">
            <span>名称：</span>
            <el-input placeholder="请输入菜单名称" v-model="searchName"></el-input>
          </div>
          <el-button type="primary" plain @click="search_fn" class="search-btn">查询</el-button>
        </div>
        <div class="mytable">
          <el-table ref="multipleTable" :data="tableData" tooltip-effect="dark" style="width: 100%" :height="heights"
            border @selection-change="handleSelectionChange">
            <el-table-column type="selection" align="center" width="44">
            </el-table-column>
            <el-table-column width="60" label="序号" align="center">
              <template slot-scope="scope">
                <span>{{ scope.$index + 1 }}</span>
              </template>
            </el-table-column>

            <el-table-column label="编号" width="90">
              <template slot-scope="scope">{{ scope.row.no }}</template>
            </el-table-column>
            <el-table-column prop="name" label="名称">
            </el-table-column>

          </el-table>

        </div>
      </div>

      <!-- 新增修改 -->
      <el-dialog :title="textMap[dialogStatus]" :close-on-click-modal='false' v-dialogDrag :visible.sync="dialogVisible"
        center>

        <div style="display: flex;" class="mydialog">
          <el-form :model="temp" ref="temp" :rules="rules" style="width: 100%;height: 120px;padding-top: 10px;">
            <el-form-item label="名称:" prop="name">
              <el-input v-model="temp.name"></el-input>
            </el-form-item>

            <el-form-item label="计量单位:" prop="unit">
              <el-input v-model="temp.unit"></el-input>
            </el-form-item>

          </el-form>
        </div>
        <template #footer>
          <span class="dialog-footer">
            <el-button @click="dialogVisible = false">取 消</el-button>
            <el-button type="primary" @click="dialogStatus==='edit'?edit_fn('temp'):add_fn('temp')">确 定
            </el-button>
          </span>
        </template>
      </el-dialog>
    </div>
  </div>
</template>
<script>
  import {findAppTypeTree,findAllAppTypeByGroupIsNull,apptypeGroupSave,apptypeGroupDeleteById,addAppTypeToGroup,removAppTypeToGroup,moveLocation} from "../../api/application";
  export default {
    data () {
      return {
        dialogTableVisible: false,
        list: [],//绑定设备列表數據
        toggleRowData: [],
        total2: 0,
        total: 0,
        temp: {},
        dialogStatus: '',
        textMap: {
          add: "新增",
          edit: "编辑"
        },
        heights: document.getElementById('app').clientHeight-250,
        tableData: [{name: '2号电站',no: '12'}],
        tableDataCopy: [],
        options: [],
        typeOptions: [],
        dialogVisible: false,
        rules: {

          name: [
            {required: true,message: '请输入区域名称',trigger: 'blur'}
          ],


        },
        conditions: {},
        mainId: '',
        options: [],
        topLevel: 0,
        deviceName: "",
        searchName: "",
        multipleSelection: [],

        checkedNodes: [],
        //以下是设备列表树形
        filterText: '',
        typeGroupData: [{
          appTypeGroup: '11'
        }],//设备树形结构
        defaultProps: {
          children: 'appTypes',
          label: 'appTypeGroup.name'
        },
        flag: false,
        addDisabled: true,
        delDisabled: true,
        moveDisabled: true,
        nowGroup: '', //当前选中的类型组
        typeGroupID: "",

      };
    },
    mounted () {
      this.findAppTypeTree_fn()
      this.getList()
    },
    watch: {

      searchName (val) {
        if(val=='') {
          this.tableData=this.tableDataCopy
        }
      },
      dialogVisible: function(val) {
        // console.log(val);
        if(!val) {
          this.temp={}
        }
      },
      filterText (val) {
        this.$refs.tree.filter(val);
      }
    },
    methods: {
      //获取树形结构数据
      findAppTypeTree_fn () {

      },
      //获取列表数据
      getList () {
        findAllAppTypeByGroupIsNull().then(res => {
          if(res.code==200) {
            this.tableData=res.data
            this.tableDataCopy=res.data
          }
        })


      },
      // 添加弹窗
      add_ed () {
        this.dialogStatus='add';
        this.dialogVisible=true;
        this.$nextTick(() => {
          this.$refs["temp"].clearValidate();
        });
        // this.temp = { UpId: v || null };
      },
      //编辑弹窗
      edit_ed (v) {
        this.dialogStatus='edit';
        this.temp=Object.assign({},v);
        this.dialogVisible=true;

        this.$nextTick(() => {
          this.$refs["temp"].clearValidate();
        });

      },
      // 确认添加
      add_fn (formName) {
        this.$refs[formName].validate((valid) => {
          if(valid) {

            this.temp.uid=null
            apptypeGroupSave(this.temp).then(data => {
              // console.log("添加顶级菜单",data);
              if(data.code==200) {
                this.temp={}
                this.findAppTypeTree_fn();
                this.dialogVisible=false;
                this.$message({showClose: true,message: '添加成功',type: 'success'});
              } else {
                this.$message.error(`添加失败，${data.message}`);
              }

            })
          } else {
            return false;
          }
        });
      },
      // 确认编辑
      edit_fn (formName) {
        this.$refs[formName].validate((valid) => {
          if(valid) {

            var d={
              "uid": this.temp.id,
              "name": this.temp.name,
              "unit": this.temp.unit,
            }

            console.log(this.temp);


            apptypeGroupSave(d).then(data => {
              if(data.code==200) {
                this.getList();
                this.dialogVisible=false;
                this.$message({showClose: true,message: '修改成功',type: 'success'});
              } else {
                this.$message.error(`修改失败，${data.message}`);
              }

            })
          } else {
            return false;
          }
        });
      },
      //树节点点击
      nodeClick_fn (val) {
        if(val.hasOwnProperty('appTypes')) {
          console.log(val);
          this.typeGroupID=val.appTypeGroup.id
          this.nowGroup=val
          this.moveDisabled=false
          if(this.multipleSelection!='') {
            this.addDisabled=false
          }
          if(this.checkedNodes.length!=0) {
            this.delDisabled=false
          }
        } else {
          this.typeGroupID=""
          this.nowGroup=''
          this.moveDisabled=true
          this.addDisabled=true
          this.delDisabled=true
        }
      },
      //树形结构选中节点
      currentChecked (nodeObj,SelectedObj) {
        this.checkedNodes=SelectedObj.checkedNodes
        this.checkedNodes=this.checkedNodes.filter(item => !item.hasOwnProperty('appTypes'))
        console.log(this.checkedNodes);
        this.delDisabled=false
        if(this.checkedNodes.length==0) {
          this.delDisabled=true
        }
      },

      //输入关键字进行过滤
      filterNode (value,data) {
        if(!value) return true;
        return data.Content.Name.indexOf(value)!==-1;
      },


      //搜索设备列表
      search_fn () {
        this.tableData=this.tableDataCopy.filter((item) => item.name.includes(this.searchName));
      },



      // 勾选
      handleSelectionChange (val) {
        this.multipleSelection=''
        val.forEach(item => {
          this.multipleSelection+=","+item.no
        })
        this.multipleSelection=this.multipleSelection.slice(1)
        //   this.multipleSelection = val;
        //   console.log('勾选的',this.multipleSelection);

        this.addDisabled=false
        if(this.multipleSelection==0||this.nowGroup=='') {
          this.addDisabled=true
        }
        console.log(this.multipleSelection);
      },
      //添加应用类型到组
      add () {
        if(this.multipleSelection.length==0) {
          this.$message({showClose: true,message: '请在表格勾选需要添加的应用类型',type: 'warning'});
          return
        }
        if(this.nowGroup=="") {
          this.$message({showClose: true,message: '请选左边选中应用类型组',type: 'warning'});
          return
        }
        var d={
          'appTypeNos': this.multipleSelection,
          'groupId': this.nowGroup.appTypeGroup.id
        }
        addAppTypeToGroup(d).then(res => {
          if(res.code==200) {
            this.$message({showClose: true,message: '添加成功',type: 'success'});
            this.getList()
            this.findAppTypeTree_fn()
          } else {
            this.$message.error(`添加失败，${data.message}`);
          }
        })
      },
      //从组移除应用类型
      del () {
        var str=''
        this.checkedNodes.forEach(item => {
          str+=','+item.no
        })
        str=str.slice(1)
        if(this.checkedNodes.length==0) {
          this.$message({showClose: true,message: '请选左边选中应用类型组',type: 'warning'});
          return
        }
        if(this.nowGroup=="") {
          this.$message({showClose: true,message: '请选左边选中应用类型组',type: 'warning'});
          return
        }
        var d={
          'appTypeNos': str,
          'groupId': this.nowGroup.appTypeGroup.id
        }
        removAppTypeToGroup(d).then(res => {
          if(res.code==200) {
            this.$message({showClose: true,message: '移除成功',type: 'success'});
            this.getList()
            this.findAppTypeTree_fn()
          } else {
            this.$message.error(`移除失败，${data.message}`);
          }
        })

      },
      //上升下降
      move_fn (type) {
        if(this.nowGroup=="") {
          this.$message({showClose: true,message: '请选左边选中应用类型组',type: 'warning'});
          return
        }
        var d={
          'id': this.nowGroup.appTypeGroup.id,
          'location': type
        }
        var text=''
        if(type=='UP') {
          text="上升"
        } else {
          text='下降'
        }
        moveLocation(d).then(res => {
          if(res.code==200) {
            this.$message({showClose: true,message: `${text}成功`,type: 'success'});
            this.findAppTypeTree_fn()
          } else {
            this.$message.error(`${text}失败，${data.message}`);
          }
        })
      },

      // 删除应用类型组
      delete_fn (v) {
        this.$confirm(`是否删除 ${v.name}`,'提示',{
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          apptypeGroupDeleteById({'id': v.id}).then(data => {
            if(data.code==200) {
              this.$message({showClose: true,message: '删除成功',type: 'success'});
              this.findAppTypeTree_fn();
            } else {
              this.$message.error(`删除失败，${data.message}`);
            }
          })
        }).catch(() => {
          // ...
        });

      },





    }
  };
</script>

<style lang="scss" scoped>
  .typegroup {
    .con {
      width: 100%;
      height: 100%;
      display: flex;
      background-color: #fff;

      .left-tree {
        width: 300px;
        height: 100%;
        border-right: 1px solid #e6e6e6;
        padding: 12px 20px 20px 20px;
        box-sizing: border-box;
      }

      .dra-btns {
        width: 88px;
        margin: 0px 20px;
        margin-top: 240px;

        img {
          margin-left: 5px;
        }

        .left-add,
        .del {
          width: 88px;
          height: 32px;
          background-color: #368ED9;
          color: #fff;
          display: flex;
          align-items: center;
          justify-content: center;
          border-radius: 2px;
        }

        .del {
          background-color: #ED6547;
          margin-top: 20px;
        }

        .item {
          background-color: #DEEFFE !important;
          border: 1px solid #368ED9;
          color: #368ED9;
        }
      }

      .right-table {
        width: calc(100% - 430px);
        height: 100%;
        padding: 18px 20px 20px 20px;
        box-sizing: border-box;
        border-left: 1px solid #E6E6E6;
      }
    }

    /deep/.el-dialog {
      width: 460px !important;

    }

    .mydialog {
      /deep/.el-input {
        width: 240px !important;
      }
    }

    .public-flex {
      display: flex;
      align-items: center;
      justify-content: center;
    }

    /deep/.el-dialog__header {
      display: flex;
      align-items: center;
      border-bottom: 1px solid #E6E6E6;

      span {
        color: #67A3ED;
        font-size: 14px;
        font-weight: bold;
      }

      .el-icon-close {
        font-size: 20px !important;
      }

    }

    /deep/.el-dialog__footer {
      margin-top: 20px;
      text-align: right !important;
      border-top: 1px solid #E6E6E6;

      button {
        padding: 8px 17px;
      }
    }



    /deep/.el-form-item {
      display: flex;
      margin-left: 20px;
    }

    /deep/.el-form-item__label {
      white-space: nowrap;
      width: 86px;
    }

    /deep/.el-dialog__body {
      padding: 20px 0px 0px 20px !important;
    }


  }
</style>